import { Theme } from '@mui/material/styles'
import { MuiLinkOverrides } from './components/Link'
import { CssBaselineOverrides } from './components/CssBaseline'
import { MuiPaperOverrides } from './components/Paper'
import { ButtonOverrides } from './components/Button'
import { InputOverrides } from './components/Input'
import { SwitchOverrides } from './components/Switch'
import { MenuOverrides } from './components/Menu'
import { AlertOverrides } from './components/Alert'
import ChipOverrides from './components/Chip'
import { DialogOverrides } from './components/Dialog'
import { ModalOverrides } from './components/Modal'

export function componentsOverrides(theme: Theme) {
  return Object.assign(
    Object.assign(CssBaselineOverrides(theme)),
    MuiLinkOverrides(),
    MuiPaperOverrides(theme),
    ButtonOverrides(theme),
    InputOverrides(theme),
    SwitchOverrides(),
    MenuOverrides(theme),
    ChipOverrides(theme),
    AlertOverrides(theme),
    DialogOverrides(),
    ModalOverrides(),
  )
}
